import { Input } from 'src/shared/components/ui/input'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { renderTextWithLinks } from 'src/shared/utils/renderTextWithLinks'

/**
 * Line-item notes (sizes, special instructions, etc.).
 * Editable whenever the order isn't read-only — no need for table Edit mode.
 */
export const LineItemNotesField = ({
  value,
  onChange,
  canEdit,
  readOnlyNote,
}: {
  value: string
  onChange: (v: string) => void
  canEdit: boolean
  readOnlyNote?: string | null
}) => {
  const { t } = useLocalization()

  if (!canEdit) {
    const text = readOnlyNote?.trim()
    if (!text) return null
    return (
      <p className="text-xs text-gray-600">{renderTextWithLinks(text)}</p>
    )
  }

  return (
    <Input
      variant="plain"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      placeholder={t('Notes (e.g. sizes)', 'Anteckningar (t.ex. storlekar)')}
      className="mt-0.5 w-full text-xs text-gray-600 placeholder:text-gray-400/60"
    />
  )
}
